export default () => ({
  company: null,
  option: null,
  hasData: false,
  subcontractors: [],
  error: '',
});
